import { createAction } from '@reduxjs/toolkit';
import { ProductType } from 'types/product.types';
import { CheckoutSnapshotParams } from 'utils/getCheckoutSnapshot';

export const buyButtonClicked = createAction<ProductType>('productDetails/BUY_BUTTON_CLICKED');
export const makeOfferButtonClicked = createAction<ProductType>('productDetails/MAKE_OFFER_BUTTON_CLICKED');

export interface CheckoutStartedPayload {
  product: ProductType;
  shopSlug: string;
  checkoutVisitId: string;
  // displayed-state snapshot (DEV-2119) — spread flat into the checkout_start GTM event
  snapshot: CheckoutSnapshotParams;
}

export const checkoutStarted = createAction<CheckoutStartedPayload>('productDetails/CHECKOUT_STARTED');
